module.exports = __webpack_public_path__ + "img/payment-th.42c52314.svg";